import type { operations } from '@/types/schemas/api.main';
import { GET, setParams } from '../../_http';
type controller = operations['PublicPostCodeLookupController_get'];

export type PostCodeQuery = controller['parameters']['query'];
export type PostCodeResponse = controller['responses']['200']['content']['application/json'];

export const postCode = GET('/public/post-code', setParams<PostCodeQuery>)<PostCodeResponse>;
